import clsx from "clsx";

type CustomButtonProps = React.DetailedHTMLProps<
	React.ButtonHTMLAttributes<HTMLButtonElement>,
	HTMLButtonElement
>;

export default function CustomButton(Props: CustomButtonProps) {
	const { disabled, className } = Props;
	return (
		<button
			{...Props}
			className={clsx(
				!disabled
					? className || ""
					: "bg-gradient-to-r from-[#808080] to-[#b3b3b3] text-white",
				"w-full justify-center rounded-md px-3 py-2 shadow-sm",
			)}
		/>
	);
}
